var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "solutions-area section-width ptb-100" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        !_vm.news
          ? _c("b-spinner", {
              attrs: { variant: "primary", label: "Spinning" }
            })
          : _vm._e(),
        _vm.news
          ? _c("div", [
              _c("h3", { staticClass: "news-date" }, [
                _vm._v(_vm._s(_vm.postDate))
              ]),
              _c("h2", { staticClass: "news-detail-title" }, [
                _vm._v(_vm._s(_vm.news.message_title))
              ]),
              _c("div", { staticClass: "card mb-3" }, [
                _c("div", { staticClass: "card-body ck-content" }, [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.news.message_content) }
                  }),
                  _vm.news.attachment && _vm.news.attachment.length
                    ? _c(
                        "div",
                        { staticClass: "attachments" },
                        _vm._l(_vm.news.attachment, function(file, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "attachment-item" },
                            [
                              _vm._m(0, true),
                              _c("span", { staticClass: "file-name" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      file.description ||
                                        file.file_description ||
                                        file.file_name
                                    ) +
                                    " "
                                ),
                                _c("span", { staticClass: "file-ext" }, [
                                  _vm._v(
                                    "." +
                                      _vm._s(
                                        _vm.getFileExtension(file.file_name)
                                      )
                                  )
                                ])
                              ]),
                              _c("i", {
                                staticClass:
                                  "bi bi-download clickable-icon download-icon",
                                on: {
                                  click: function($event) {
                                    return _vm.downloadFile(
                                      file.path,
                                      file.file_name
                                    )
                                  }
                                }
                              })
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ])
              ])
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "bi bi-tag-fill" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }